import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { AllMaterialModule } from 'src/app/material-module';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { AuthFacadeService } from 'src/app/modules/auth/state/auth/auth.facade.service';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { StoreModule } from '@ngrx/store';
import { authReducer } from 'src/app/modules/auth/state/auth/auth.reducers';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffect } from 'src/app/modules/auth/state/auth/auth.effects';
import { OnlyNumbersDirective } from 'src/app/common/directives/only-numbers.directive';
import { LoginWithPasswordComponent } from './login-with-password/login-with-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ModalwindowModule } from 'src/app/modules/shared/modal-window/modal-window-model';


@NgModule({
  declarations: [
    AuthComponent,
    LoginComponent,
    VerifyOtpComponent,
    OnlyNumbersDirective,
    LoginWithPasswordComponent,
    ForgotPasswordComponent
  ],
  imports: [
    ModalwindowModule,
    CommonModule,
    AuthRoutingModule,
    AllMaterialModule,
    NgOtpInputModule,
    StoreModule.forFeature('AUTH', authReducer),
    EffectsModule.forFeature([AuthEffect]),
  ],
  exports: [
    
    OnlyNumbersDirective,
  ]
  ,
  providers : [AuthFacadeService]
})
export class AuthModule { }
